import { AbstractControl, ValidationErrors } from '@angular/forms';

export function getLastYearDate(): Date {
  const d = new Date();
  d.setFullYear(d.getFullYear() - 1);
  d.setDate(d.getDate() + 1);
  return d;
}

/**
 * Validator to check if a date is within last year.
 *
 * This validator compares the input date with the min signature date (today - 1 year).
 * If the input date is after the min date, the validation passes.
 * Otherwise, it returns an error object with the key "minDate".
 *
 * @returns A ValidatorFn that returns null if the validation passes,
 *          or an object with the key "minDate" if the validation fails.
 */

export function minSignatureDateValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) return null;
  const date = new Date(control.value);
  return date >= getLastYearDate() ? null : { minSignatureDate: true };
}
